export default __webpack_public_path__ + "static/media/setting.fafd51e8.svg";